/**
 * One-shot handoff for seating a live consultant (CRM rep) into a LiveKit demo.
 *
 * The rep accepts a ringing demo in the CRM inbox, the Node ring seats them via
 * `livecall_agent` and returns a pre-minted LiveKit grant. That grant cannot ride the URL
 * (`sessionStorage` is per-tab and `noopener` gives the new tab an empty one), so the inbox
 * stashes it in `localStorage` under a nonce and opens the LiveKit call page at
 * `/instant-demo-v2/call?...&repHandoff=<nonce>`. The call page reads it once and connects as a
 * PUBLISHING participant (identity `rep-…`), mirroring the admin-observer handoff but not hidden.
 *
 * Defined here, next to its CONSUMER (the LiveKit call page), and re-exported from
 * `tracking-demo/agent-request.models` so the shared inbox and the call page agree on one key.
 */

/** localStorage key prefix; the full key is `cdlkRepHandoff:<nonce>`. */
export const REP_JOIN_HANDOFF_PREFIX = 'cdlkRepHandoff';

/** Payload stored under {@link REP_JOIN_HANDOFF_PREFIX}. Room + product also ride the URL. */
export interface RepJoinHandoff {
  /** The LiveKit JWT to connect with. */
  token: string;
  /** The LiveKit server URL (backend-supplied; never configured on the client). */
  ws_url: string;
  /** The LiveKit room name. */
  room: string;
  /** The product slug, so the deck stage renders (derived from the room name). */
  product: string;
  /** The rep's participant identity (`rep-<pid>`). */
  identity: string;
  /** Roster label, e.g. "Himanshu Saini (Consultant)". */
  name: string;
}
